export const TRIBUTACAO_ISSQN_NFSE_NACIONAL_OPTIONS = [
  { value: 1, textKey: "tributacaoIssqnNfseTributavel" },
  { value: 2, textKey: "tributacaoIssqnNfseImunidade" },
  { value: 3, textKey: "tributacaoIssqnNfseExportacao" },
  { value: 4, textKey: "tributacaoIssqnNfseNaoIncidencia" },
];

export const IBS_CBS_INDICADOR_FINAL_OPTIONS = [
  { value: 0, textKey: "nao" },
  { value: 1, textKey: "sim" },
];

export const IBS_CBS_TIPO_OPERACAO_OPTIONS = [
  { value: 1, textKey: "ibsCbsTipoOperacao1" },
  { value: 2, textKey: "ibsCbsTipoOperacao2" },
  { value: 3, textKey: "ibsCbsTipoOperacao3" },
  { value: 4, textKey: "ibsCbsTipoOperacao4" },
  { value: 5, textKey: "ibsCbsTipoOperacao5" },
];

export const IBS_CBS_TIPO_ENTE_GOVERNAMENTAL_OPTIONS = [
  { value: 1, textKey: "ibsCbsEnteUniao" },
  { value: 2, textKey: "ibsCbsEnteEstado" },
  { value: 3, textKey: "ibsCbsEnteDistritoFederal" },
  { value: 4, textKey: "ibsCbsEnteMunicipio" },
];

export const IBS_CBS_INDICADOR_DESTINATARIO_OPTIONS = [
  { value: 0, textKey: "ibsCbsDestinatarioTomador" },
  {
    value: 1,
    textKey: "ibsCbsDestinatarioDiferenteNaoSuportado",
    disabled: true,
  },
];

export const ORIGEM_MERCADORIA_OPTIONS = [
  { value: "NACIONAL", textKey: "origemMercadoria0" },
  {
    value: "ESTRANGEIRA_IMPORTACAO_DIRETA",
    textKey: "origemMercadoria1",
  },
  {
    value: "ESTRANGEIRA_MERCADO_INTERNO",
    textKey: "origemMercadoria2",
  },
  {
    value: "NACIONAL_CONTEUDO_IMPORTACAO_SUPERIOR_40_ATE_70",
    textKey: "origemMercadoria3",
  },
  {
    value: "NACIONAL_PROCESSOS_PRODUTIVOS_BASICOS",
    textKey: "origemMercadoria4",
  },
  {
    value: "NACIONAL_CONTEUDO_IMPORTACAO_INFERIOR_OU_IGUAL_40",
    textKey: "origemMercadoria5",
  },
  {
    value: "ESTRANGEIRA_IMPORTACAO_DIRETA_SEM_SIMILAR",
    textKey: "origemMercadoria6",
  },
  {
    value: "ESTRANGEIRA_MERCADO_INTERNO_SEM_SIMILAR",
    textKey: "origemMercadoria7",
  },
  {
    value: "NACIONAL_CONTEUDO_IMPORTACAO_SUPERIOR_70",
    textKey: "origemMercadoria8",
  },
];

export const TIPO_ESPECIE_FISCAL_GTVE_OPTIONS = [
  { value: "CEDULA", textKey: "tipoEspecieFiscalCedula" },
  { value: "CHEQUE", textKey: "tipoEspecieFiscalCheque" },
  { value: "MOEDA", textKey: "tipoEspecieFiscalMoeda" },
  { value: "OUTROS", textKey: "tipoEspecieFiscalOutros" },
];

export const TIPO_AMBIENTE_EMISSAO_OPTIONS = [
  { value: "HOMOLOGACAO", textKey: "ambienteFiscalHomologacao" },
  { value: "PRODUCAO", textKey: "ambienteFiscalProducao" },
];

export const TIPO_NUMERARIO_TRANSPORTADO_OPTIONS = [
  { value: "NACIONAL", textKey: "tipoNumerarioNacional" },
  { value: "ESTRANGEIRO", textKey: "tipoNumerarioEstrangeiro" },
];
